module.exports = __webpack_public_path__ + "img/search_selected.0af59dd8.svg";